var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame7(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328,
    height: 328,
    viewBox: "0 0 328 328",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7563E7",
    stroke: "#242424",
    strokeWidth: 4,
    strokeLinejoin: "bevel",
    d: "M326 326H2V2h324z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M326 326H2L326 2v324z",
    fill: "#F2DA3A",
    stroke: "#242424",
    strokeWidth: 4,
    strokeLinejoin: "bevel"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M326 163.998a161.985 161.985 0 01-47.449 114.549A162.001 162.001 0 01164 325.996V163.998h162z",
    fill: "#F68282",
    stroke: "#242424",
    strokeWidth: 4,
    strokeLinejoin: "bevel"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzI4IiBoZWlnaHQ9IjMyOCIgdmlld0JveD0iMCAwIDMyOCAzMjgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHJlY3QgeD0iMzI2IiB5PSIzMjYiIHdpZHRoPSIzMjQiIGhlaWdodD0iMzI0IiB0cmFuc2Zvcm09InJvdGF0ZSgtMTgwIDMyNiAzMjYpIiBmaWxsPSIjNzU2M0U3IiBzdHJva2U9IiMyNDI0MjQiIHN0cm9rZS13aWR0aD0iNCIgc3Ryb2tlLWxpbmVqb2luPSJiZXZlbCIvPgogIDxwYXRoIGQ9Ik0zMjYgMzI2TDEuOTk5OTcgMzI2TDMyNiAyLjAwMDA2TDMyNiAzMjZaIiBmaWxsPSIjRjJEQTNBIiBzdHJva2U9IiMyNDI0MjQiIHN0cm9rZS13aWR0aD0iNCIgc3Ryb2tlLWxpbmVqb2luPSJiZXZlbCIvPgogIDxwYXRoIGQ9Ik0zMjYgMTYzLjk5OEMzMjYgMTg1LjI3MiAzMjEuODEgMjA2LjMzNyAzMTMuNjY4IDIyNS45OTJDMzA1LjUyNyAyNDUuNjQ2IDI5My41OTQgMjYzLjUwNSAyNzguNTUxIDI3OC41NDdDMjYzLjUwOCAyOTMuNTkgMjQ1LjY0OSAzMDUuNTIzIDIyNS45OTUgMzEzLjY2NEMyMDYuMzQgMzIxLjgwNSAxODUuMjc0IDMyNS45OTYgMTY0IDMyNS45OTZMMTY0IDE2My45OThMMzI2IDE2My45OThaIiBmaWxsPSIjRjY4MjgyIiBzdHJva2U9IiMyNDI0MjQiIHN0cm9rZS13aWR0aD0iNCIgc3Ryb2tlLWxpbmVqb2luPSJiZXZlbCIvPgo8L3N2Zz4K";
export { SvgFrame7 as ReactComponent };